/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isPersonalPortal } from 'actions/common';
import { getCompanySettings } from 'actions/common/companySettings';

import launchModal from 'containers/Network/AnnualUpdateReminderModal';

import useQueryParams from 'hooks/location/useQueryParams';

import { useHasNotDoneBigAction, useHasLoggedInOnThisPage } from '../utils';

const AnnualUpdateReminderWorkflowStep = ({
  active,
  updateState
}) => {
  // Hooks
  const dispatch = useDispatch();
  const { forceNotification } = useQueryParams([ 'forceNotification' ]);

  const hasFlag = useSelector(
    state => getCompanySettings(state).annualUpdateReminder === true
  );
  const hasNotDoneBigAction = useHasNotDoneBigAction();
  const loggedInThisPage = useHasLoggedInOnThisPage();
  const shouldShow = hasFlag && loggedInThisPage && hasNotDoneBigAction;

  const canShow = useSelector(state => !isPersonalPortal(state));

  const willShow = canShow && (forceNotification === 'annualUpdateReminder' || shouldShow);

  useEffect(
    () => {
      updateState(!willShow ? 'skipped' : 'loaded');
    },
    [ willShow ]
  );

  const execute = async () => {
    dispatch({ type: 'HasDoneOncePerSessionAction' });
    await dispatch(launchModal({}));
    updateState('completed');
  };

  useEffect(
    () => {
      if (willShow && active) {
        // useEffect doesn't like being passed an async function - hence why this broken out
        execute();
      }
    },
    [ active ]
  );

  // Render
  return <></>;
};

export default AnnualUpdateReminderWorkflowStep;